var Clipboard = require('clipboard/dist/clipboard.min.js') // FIXME: workaround for browserify

var VueClipboardConfig = {
  autoSetContainer: false
}

export default {
  install: function(Vue) {
    Vue.prototype.$isCopySupport = Clipboard.isSupported()
    Vue.directive('clipboard', {
      bind: function(el, binding, vnode) {
        if (binding.arg === 'success') {
          el._vClipboard_success = binding.value
        } else if (binding.arg === 'error') {
          el._vClipboard_error = binding.value
        } else {
          var clipboard = new Clipboard(el, {
            text: function() {
              return binding.value
            },
            action: function() {
              return binding.arg === 'cut' ? 'cut' : 'copy'
            },
            container: VueClipboardConfig.autoSetContainer ? el : undefined
          })
          clipboard.on('success', function(e) {
            var callback = el._vClipboard_success
            callback && callback(e, binding.value)
          })
          clipboard.on('error', function(e) {
            var callback = el._vClipboard_error
            callback && callback(e, binding.value)
          })
          el._vClipboard = clipboard
        }
      },
      update: function(el, binding) {
        if (binding.arg === 'success') {
          el._vClipboard_success = binding.value
        } else if (binding.arg === 'error') {
          el._vClipboard_error = binding.value
        } else {
          el._vClipboard.text = function() {
            return binding.value
          }
          el._vClipboard.action = function() {
            return binding.arg === 'cut' ? 'cut' : 'copy'
          }
        }
      },
      unbind: function(el, binding) {
        if (binding.arg === 'success') {
          delete el._vClipboard_success
        } else if (binding.arg === 'error') {
          delete el._vClipboard_error
        } else {
          el._vClipboard.destroy()
          delete el._vClipboard
        }
      }
    })
  }
}
